import React from "react";
import styles from "./AllFiltersButton.module.scss";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";

import { useDispatch, useSelector } from "react-redux";
import { overlayActions } from "../../store/redux/store";

const AllFiltersButton = (props) => {
    const dispatch = useDispatch();
    const toggleAllFiltersOverlay = () => {
        dispatch(overlayActions.toggleAllFiltersOverlay());
    };

    const { initAllFiltersOverlay } = useSelector((state) => state.overlay);
    return (
        initAllFiltersOverlay && (
            <div
                className={styles["show-all-filters-button"]}
                onClick={() => {
                    toggleAllFiltersOverlay();
                }}
            >
                Filter anzeigen
                <FilterIcon />
            </div>
        )
    );
};

export default AllFiltersButton;
